import { render, staticRenderFns } from "./warn-info-import-details.vue?vue&type=template&id=4b9ef89f&scoped=true"
import script from "./warn-info-import-details.vue?vue&type=script&lang=ts"
export * from "./warn-info-import-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9ef89f",
  null
  
)

export default component.exports